import Rails from "@rails/ujs";

export const handleConfirm = (message: string, element: HTMLElement) => new Promise((resolve) => {
  const dialog: HTMLDialogElement | null = document.querySelector("dialog#turbo_confirm");

  if (dialog) {
    const titleElement = dialog.querySelector("[data-title]") as HTMLElement;
    const contentElement = dialog.querySelector("[data-content]") as HTMLElement;
    const cancelButton = dialog.querySelector("button[data-cancel]") as HTMLButtonElement;
    const submitButton = dialog.querySelector("button[data-submit]") as HTMLButtonElement;

    if (element.dataset.confirmHtml != null) {
      contentElement.innerHTML = message;
    } else {
      contentElement.textContent = message;
    }
    titleElement.textContent = (element.dataset.confirmTitle || element.title || dialog.dataset.title) as string;
    cancelButton.textContent = (element.dataset.confirmCancel || dialog.dataset.cancel) as string;
    submitButton.textContent = (element.dataset.confirmSubmit || dialog.dataset.submit) as string;

    dialog.showModal();
    submitButton.focus();

    submitButton.addEventListener("click", () => {
      submitButton.innerText = (element.dataset.disableWith || element.dataset.turboSubmitsWith || dialog.dataset.loading) as string;
      submitButton.disabled = true;

      // Handle cleanup of dialog if not removed automatically
      if (element.dataset.turbo === "true" || element.dataset.remote === "true" || element.dataset.reload) {
        setTimeout(() => {
          submitButton.disabled = false;
          dialog.close();
          if (element.dataset.reload) window.location.reload();
        }, 750);
      }

      return resolve(true);
    }, {once: true});

    dialog.addEventListener("close", () => {
      submitButton.disabled = false;
      submitButton.textContent = (element.dataset.confirmSubmit || dialog.dataset.submit) as string;
      resolve(false);
    }, {once: true});
  } else {
    // Fallback if element is missing
    return resolve(confirm(message));
  }
});

export const handleRailsConfirm = (message: string, element: HTMLElement) => {
  handleConfirm(message, element)
    .then(confirmed => {
      if (confirmed) {
        const old = Rails.confirm;
        Rails.confirm = () => true;
        element.click();
        Rails.confirm = old;
      }
    });

  return false;
};
